import { TRootState } from "Redux/Reducers";

export const getEventTicket = (id: string) => (state: TRootState) => state.eventTicket.entries[id];
